import Device from 'src/Device';

export default class Prestations {
	constructor(classname) {
		this.sections = document.querySelectorAll(`.${classname}`);
		this.sections.forEach((section) => new Section(section));
	}
}

class Section {
	itemSelector = '.prestations__item';
	descriptionSelector = '.prestations__description';

	constructor(section) {
		this.section = section;

		this.items = this.section.querySelectorAll(this.itemSelector);
		this.descriptions = this.section.querySelectorAll(this.descriptionSelector);
		this.items.forEach((item, index) => item.addEventListener('click', () => this.toggleDescription(index)));

		window.addEventListener('resize', () => this.setDescriptionsMaxHeight());
		this.setDescriptionsMaxHeight();
	}

	setDescriptionsMaxHeight() {
		const navigation = this.section.querySelector('.prestations__navigation');
		const descriptions = this.section.querySelector('.prestations__descriptions');
		descriptions.style.maxHeight = navigation.clientHeight + 'px';
	}

	getActiveItems() {
		return this.section.querySelectorAll(`${this.itemSelector}.active`);
	}

	getActiveDescriptions() {
		return this.section.querySelectorAll(`${this.descriptionSelector}.active`);
	}

	toggleDescription(index) {
		const item = this.items[index];
		const description = this.descriptions[index];
		if (!item || !description) return;

		const activeItems = this.getActiveItems();
		const activeDescriptions = this.getActiveDescriptions();

		activeItems.forEach((item) => item.classList.remove('active'));
		activeDescriptions.forEach((item) => item.classList.remove('active'));

		item.classList.add('active');
		description.classList.add('active');

		// Mobile accordeon
		const mobileActiveDescriptions = this.section.querySelectorAll(
			'.prestations__navigation ' + this.descriptionSelector
		);
		mobileActiveDescriptions.forEach((item) => item.parentElement.removeChild(item));

		const mobileDescription = description.cloneNode(true);
		mobileDescription.classList.remove('active');
		item.after(mobileDescription);
	}
}
